module.exports = __webpack_public_path__ + "img/recruiting_DrThummGmbH_RZ_RGB.103e3112.png";